import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@material-ui/core';
import { withTranslation } from 'react-i18next';

// HELP
import StatisticItem from './help/StatisticItem/StatisticItem';

// STYLES
import { StatisticContainer } from './styles';

const Statistic = ({ t, numberOfApps }) => {
  const statisticData = [
    { title: '$600+', titleColor: 'purple', text: 'home.statistic.items.item1' },
    { title: '3 Minutes', titleColor: 'primary', text: 'home.statistic.items.item2' },
    { title: '100M+', titleColor: 'error', text: 'home.statistic.items.item3' },
    { title: numberOfApps, titleColor: 'blue', text: 'home.statistic.items.item4' },
  ];

  return (
    <StatisticContainer className="section section--grey statistic content-visibility--auto">
      <div className="page-content">
        <Typography className="m-b-10" variant="h3">
          {t('home.statistic.title')}{' '}
          <span role="img" aria-label="thinking-face">
            &#129488;
          </span>
        </Typography>
        <Typography variant="subtitle2">{t('home.statistic.subtitle')}</Typography>
        <div className="statistic__items">
          <Grid container spacing={4}>
            {statisticData.map((item, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <StatisticItem
                  title={item.title}
                  titleColor={item.titleColor}
                  text={t(item.text)}
                />
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
    </StatisticContainer>
  );
};

Statistic.propTypes = {
  t: PropTypes.func.isRequired,
  numberOfApps: PropTypes.string.isRequired,
};

export default withTranslation()(React.memo(Statistic));
